export default class VideoShift {
  constructor(config) {
    this.config = config
    this.changeFn = this.config.changeFn
    this.videoElm = this.config.videoElm
    ;(this.landscapeVideoSrc = this.config.landscapeVideoSrc), // 横長の時の動画パス
      (this.portraitVideoSrc = this.config.portraitVideoSrc), // 縦長の時の動画パス
      (this.videoClass = this.config.videoClass || 'shift_video')
    this.srcElm
    this.curTime = 0
    this.winWidth = window.innerWidth
    this.winHeight = window.innerHeight
    this.windowRatio =
      this.winWidth >= this.winHeight ? 'landscape' : 'portrait'
    this.removeElm

    // function
    // ------------------------------
    this.createVideoElm()

    window.addEventListener('resize', () => this.refresh())
  }

  createVideoElm() {
    const source = document.createElement('source')
    source.src =
      this.windowRatio === 'landscape'
        ? this.landscapeVideoSrc
        : this.portraitVideoSrc
    this.srcElm = source

    this.videoElm.appendChild(source)
    if (this.removeElm) this.removeElm.remove()

    this.videoElm.load()
    this.videoElm.currentTime = this.curTime
    this.videoElm.play()
  }

  refresh() {
    const wr = this.windowRatio
    this.winWidth = window.innerWidth
    this.winHeight = window.innerHeight
    this.windowRatio =
      this.winWidth >= this.winHeight ? 'landscape' : 'portrait'
    if (wr !== this.windowRatio) {
      this.curTime = this.videoElm.currentTime
      this.removeElm = this.srcElm
      this.createVideoElm()
      if (this.changeFn) this.changeFn()
    }
  }
}

/* 
<video class="firstView_video" playsinline muted></video>
↑これを入れる！
*/
